// Sample news data
export const sampleNews = [
    {
        id: 1,
        title: "Mantenimiento Programado de Ascensores",
        category: "mantenimiento",
        content: "Se realizará mantenimiento preventivo en los ascensores del edificio A y B el próximo martes 15 de octubre. El servicio comenzará a las 9:00 AM y finalizará aproximadamente a las 2:00 PM. Durante este tiempo, los ascensores estarán fuera de servicio.",
        date: "2024-10-10",
        likes: 12,
        comments: 3
    },
    {
        id: 2,
        title: "Asamblea General Extraordinaria",
        category: "eventos",
        content: "Se convoca a asamblea general extraordinaria para tratar el presupuesto anual 2025 y aprobación de nuevas obras de mejoramiento. La reunión se realizará en el salón social el sábado 20 de octubre a las 10:00 AM.",
        date: "2024-10-08",
        likes: 25,
        comments: 8
    },
    {
        id: 3,
        title: "Nuevo Sistema de Seguridad Implementado",
        category: "avisos",
        content: "Informamos a todos los residentes que se ha implementado un nuevo sistema de cámaras de seguridad en áreas comunes. El sistema opera 24/7 y ha mejorado significativamente la vigilancia del condominio.",
        date: "2024-10-05",
        likes: 18,
        comments: 5
    },
    {
        id: 4,
        title: "Pintura de Fachadas - Próximo Mes",
        category: "mantenimiento",
        content: "Se programó el mantenimiento de pintura de fachadas para el próximo mes. Se coordinará con cada torre para minimizar las molestias. Se emitirá un cronograma detallado la próxima semana.",
        date: "2024-10-03",
        likes: 15,
        comments: 2
    },
    {
        id: 5,
        title: "Fiesta de Fin de Año",
        category: "eventos",
        content: "Comité social organiza fiesta de fin de año para todos los residentes. El evento se realizará el 31 de diciembre en el salón social a partir de las 8:00 PM. Habrá música, comida y premios. Confirmar asistencia antes del 20 de diciembre.",
        date: "2024-10-01",
        likes: 42,
        comments: 12
    },
    {
        id: 6,
        title: "Recordatorio: Pago de Cuotas",
        category: "avisos",
        content: "Recordamos a todos los residentes que el plazo para el pago de las cuotas mensuales vence el día 10 de cada mes. Pagos fuera de fecha generarán intereses. Se aceptan transferencias bancarias y pagos en línea.",
        date: "2024-09-28",
        likes: 8,
        comments: 1
    }
];

// Utility functions
export const utils = {
    getCategoryLabel(category) {
        const labels = {
            'mantenimiento': 'Mantenimiento',
            'eventos': 'Eventos',
            'avisos': 'Avisos'
        };
        return labels[category] || category;
    },

    formatDate(dateString) {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString('es-ES', options);
    },

    copyToClipboard(text) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
    },

    getNotificationIcon(type) {
        const icons = {
            'success': 'check-circle',
            'info': 'info-circle',
            'error': 'exclamation-circle'
        };
        return icons[type] || 'info-circle';
    },

    setTodayDate() {
        const today = new Date().toISOString().split('T')[0];
        const dateInput = document.getElementById('newsDate');
        if (dateInput) {
            dateInput.value = today;
        }
    }
};
